export default __webpack_public_path__ + "static/media/sort-icon.4233ce5c.svg";